import React from "react";
import { Phone, MapPin } from "lucide-react";
import "./Footer.css";

const exploreLinks = [
  { label: "Why Us", href: "#why-us" },
  { label: "Process", href: "#process" },
  { label: "Get Quote", href: "#contact" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <h2 className="footer__logo">Durga Gold</h2>
          <p className="footer__tagline">
            Chennai's trusted gold buyers. We offer instant cash for used
            gold — safely, transparently and with 100% guarantee.
          </p>
          <button className="footer__cta">Get Instant Cash Quote</button>
        </div>

        <div className="footer__col">
          <span className="footer__heading">Reach Us</span>

          <div className="footer__contact-item">
            <Phone className="footer__icon" size={16} strokeWidth={1.75} />
            <span>98844 42716</span>
          </div>

          <div className="footer__contact-item">
            <MapPin className="footer__icon" size={16} strokeWidth={1.75} />
            <span>
              No.157 PMG Complex, South
              <br />
              Usman Road, T. Nagar, Chennai
              <br />
              600017
            </span>
          </div>
        </div>

        <div className="footer__col">
          <span className="footer__heading">Explore</span>
          <ul className="footer__links">
            {exploreLinks.map((link) => (
              <li key={link.label}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer__divider" />

      <div className="footer__bottom">
        <span>© 2026 Durga Gold. All rights reserved. Compliant with all statutory bodies.</span>
        <span>Rates are indicative · Final value confirmed after in-store testing.</span>
      </div>
    </footer>
  );
}
